module.exports = __webpack_public_path__ + "media/images/posts/why_choose_winter_wedding2-7dcdf47effd8452094d33ecacbfffbdd.jpg";